import Modal from '@/shared/ui/Modal';
import { motion } from 'motion/react';
import { useIsMobile } from '@/modules/use-window-width';
import type { OnboardingPath } from './context';

// Deliberately no viz preview, unlike the welcome modal's path cards.
export default function FinishModal({
  path,
  onSeeOther,
  onClose,
}: {
  path: OnboardingPath;
  onSeeOther: () => void;
  onClose: () => void;
}) {
  const isMobile = useIsMobile();
  const trader = path === 'trader';
  return (
    // ✕ only on the mobile sheet (the desktop card has none); backdrop
    // clicks don't close: the two buttons are the decision point.
    <Modal
      closeModal={onClose}
      closeOnOverlayClick={false}
      withoutCross={!isMobile}
      sheet
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 260, damping: 26 }}
        className="w-125 max-w-[92vw] px-3xl pt-2xl pb-3xl text-gray-text max-md:w-full max-md:max-w-full max-md:p-l"
      >
        <p className="text-h2 font-bold">Welcome on board!</p>
        <p className="mt-2xl text-body-lg text-gray max-md:mt-s">
          {trader ?
            'See Backer tour or post your first prediction!'
          : 'See Trader tour or get started!'}
        </p>
        <div className="mt-2xl flex gap-s max-md:mt-l max-md:flex-col">
          {/* flex-1 only in the desktop ROW — in the mobile column its
              flex-basis:0 overrides h-10 on the main axis and the buttons
              collapse to text height */}
          <button
            type="button"
            onClick={onSeeOther}
            className="btn-reset h-10 rounded-sm bg-purple-01 text-center text-body-md font-medium text-purple-default md:flex-1"
          >
            {trader ? 'See Backer tour' : 'See Trader tour'}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="btn-reset h-10 rounded-sm bg-purple-default text-center text-body-md font-medium text-gray-inverse hover:bg-purple-hover md:flex-1"
          >
            Get started
          </button>
        </div>
      </motion.div>
    </Modal>
  );
}
